import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';
import RewardReportParse from 'src/helpers/modular/rewardReport/parser';
import TimeTableRewardsParse from 'src/helpers/modular/timeTableRewardTotals/parser';
export var RewardsActions;
(function (RewardsActions) {
    RewardsActions["GET_REWARD_TYPES_REQUEST"] = "GET_REWARD_TYPES_REQUEST";
    RewardsActions["GET_REWARD_TYPES_SUCCESS"] = "GET_REWARD_TYPES_SUCCESS";
    RewardsActions["GET_REWARD_TYPES_FAIL"] = "GET_REWARD_TYPES_FAIL";
    RewardsActions["POST_REWARD_TYPE_REQUEST"] = "POST_REWARD_TYPE_REQUEST";
    RewardsActions["POST_REWARD_TYPE_SUCCESS"] = "POST_REWARD_TYPE_SUCCESS";
    RewardsActions["POST_REWARD_TYPE_FAIL"] = "POST_REWARD_TYPE_FAIL";
    RewardsActions["DELETE_REWARD_TYPE_REQUEST"] = "DELETE_REWARD_TYPE_REQUEST";
    RewardsActions["DELETE_REWARD_TYPE_SUCCESS"] = "DELETE_REWARD_TYPE_SUCCESS";
    RewardsActions["DELETE_REWARD_TYPE_FAIL"] = "DELETE_REWARD_TYPE_FAIL";
    RewardsActions["GET_REWARD_REGISTRY_REQUEST"] = "GET_REWARD_REGISTRY_REQUEST";
    RewardsActions["GET_REWARD_REGISTRY_SUCCESS"] = "GET_REWARD_REGISTRY_SUCCESS";
    RewardsActions["GET_REWARD_REGISTRY_FAIL"] = "GET_REWARD_REGISTRY_FAIL";
    RewardsActions["POST_REWARD_REGISTRY_ITEM_REQUEST"] = "POST_REWARD_REGISTRY_ITEM_REQUEST";
    RewardsActions["POST_REWARD_REGISTRY_ITEM_SUCCESS"] = "POST_REWARD_REGISTRY_ITEM_SUCCESS";
    RewardsActions["POST_REWARD_REGISTRY_ITEM_FAIL"] = "POST_REWARD_REGISTRY_ITEM_FAIL";
    RewardsActions["DELETE_REWARD_REGISTRY_ITEM_REQUEST"] = "DELETE_REWARD_REGISTRY_ITEM_REQUEST";
    RewardsActions["DELETE_REWARD_REGISTRY_ITEM_SUCCESS"] = "DELETE_REWARD_REGISTRY_ITEM_SUCCESS";
    RewardsActions["DELETE_REWARD_REGISTRY_ITEM_FAIL"] = "DELETE_REWARD_REGISTRY_ITEM_FAIL";
    RewardsActions["GET_REWARD_REPORT_REQUEST"] = "GET_REWARD_REPORT_REQUEST";
    RewardsActions["GET_REWARD_REPORT_SUCCESS"] = "GET_REWARD_REPORT_SUCCESS";
    RewardsActions["GET_REWARD_REPORT_FAIL"] = "GET_REWARD_REPORT_FAIL";
    RewardsActions["GET_PERSON_REWARDS_REQUEST"] = "GET_PERSON_REWARDS_REQUEST";
    RewardsActions["GET_PERSON_REWARDS_SUCCESS"] = "GET_PERSON_REWARDS_SUCCESS";
    RewardsActions["GET_PERSON_REWARDS_FAIL"] = "GET_PERSON_REWARDS_FAIL";
    RewardsActions["POST_PERSON_REWARD_SUCCESS"] = "POST_PERSON_REWARD_SUCCESS";
    RewardsActions["UPDATE_PERSON_REWARD_SUCCESS"] = "UPDATE_PERSON_REWARD_SUCCESS";
    RewardsActions["DELETE_PERSON_REWARD_SUCCESS"] = "DELETE_PERSON_REWARD_SUCCESS";
    RewardsActions["GET_TIMETABLE_REWARDS_REQUEST"] = "GET_TIMETABLE_REWARDS_REQUEST";
    RewardsActions["GET_TIMETABLE_REWARDS_SUCCESS"] = "GET_TIMETABLE_REWARDS_SUCCESS";
    RewardsActions["GET_TIMETABLE_REWARDS_FAIL"] = "GET_TIMETABLE_REWARDS_FAIL";
    RewardsActions["POST_TIMETABLE_REWARDS_REQUEST"] = "POST_TIMETABLE_REWARDS_REQUEST";
    RewardsActions["POST_TIMETABLE_REWARDS_SUCCESS"] = "POST_TIMETABLE_REWARDS_SUCCESS";
    RewardsActions["POST_TIMETABLE_REWARDS_FAIL"] = "POST_TIMETABLE_REWARDS_FAIL";
})(RewardsActions || (RewardsActions = {}));
export function getRewardTypesRequest() {
    return { type: RewardsActions.GET_REWARD_TYPES_REQUEST };
}
export function getRewardTypesSuccess(rewardTypes) {
    return { type: RewardsActions.GET_REWARD_TYPES_SUCCESS, payload: rewardTypes };
}
export function getRewardTypesFail() {
    return { type: RewardsActions.GET_REWARD_TYPES_FAIL };
}
export function postRewardTypeRequest() {
    return { type: RewardsActions.POST_REWARD_TYPE_REQUEST };
}
export function postRewardTypeSuccess(rewardType) {
    return { type: RewardsActions.POST_REWARD_TYPE_SUCCESS, payload: rewardType };
}
export function postRewardTypeFail() {
    return { type: RewardsActions.POST_REWARD_TYPE_FAIL };
}
export function deleteRewardTypeRequest() {
    return { type: RewardsActions.DELETE_REWARD_TYPE_REQUEST };
}
export function deleteRewardTypeSuccess(rewardTypeId) {
    return { type: RewardsActions.DELETE_REWARD_TYPE_SUCCESS, payload: rewardTypeId };
}
export function deleteRewardTypeFail() {
    return { type: RewardsActions.DELETE_REWARD_TYPE_FAIL };
}
export function getRewardRegistryRequest() {
    return { type: RewardsActions.GET_REWARD_REGISTRY_REQUEST };
}
export function getRewardRegistrySuccess(rewardRegistry) {
    return { type: RewardsActions.GET_REWARD_REGISTRY_SUCCESS, payload: rewardRegistry };
}
export function getRewardRegistryFail() {
    return { type: RewardsActions.GET_REWARD_REGISTRY_FAIL };
}
export function postRewardRegistryItemSuccess(rewardRegistryItem) {
    return { type: RewardsActions.POST_REWARD_REGISTRY_ITEM_SUCCESS, payload: rewardRegistryItem };
}
export function deleteRewardRegistryItemSuccess(rewardRegistryItemId) {
    return { type: RewardsActions.DELETE_REWARD_REGISTRY_ITEM_SUCCESS, payload: rewardRegistryItemId };
}
export function getRewardReportRequest() {
    return { type: RewardsActions.GET_REWARD_REPORT_REQUEST };
}
export function getRewardReportSuccess(rewardReport) {
    return { type: RewardsActions.GET_REWARD_REPORT_SUCCESS, payload: rewardReport };
}
export function getRewardReportFail() {
    return { type: RewardsActions.GET_REWARD_REPORT_FAIL };
}
export function getPersonRewardsRequest() {
    return { type: RewardsActions.GET_PERSON_REWARDS_REQUEST };
}
export function getPersonRewardsSuccess(personRewards) {
    return { type: RewardsActions.GET_PERSON_REWARDS_SUCCESS, payload: personRewards };
}
export function getPersonRewardsFail() {
    return { type: RewardsActions.GET_PERSON_REWARDS_FAIL };
}
export function postPersonRewardSuccess(personReward) {
    return { type: RewardsActions.POST_PERSON_REWARD_SUCCESS, payload: personReward };
}
export function updatePersonRewardSuccess(personReward) {
    return { type: RewardsActions.UPDATE_PERSON_REWARD_SUCCESS, payload: personReward };
}
export function deletePersonRewardSuccess({ id, personId }) {
    return { type: RewardsActions.DELETE_PERSON_REWARD_SUCCESS, payload: { id, personId } };
}
export function getTimetableRewardsRequest() {
    return { type: RewardsActions.GET_TIMETABLE_REWARDS_REQUEST };
}
export function getTimetableRewardsSuccess({ personsMap, columns }) {
    return { type: RewardsActions.GET_TIMETABLE_REWARDS_SUCCESS, payload: { personsMap, columns } };
}
export function getTimetableRewardsFail() {
    return { type: RewardsActions.GET_TIMETABLE_REWARDS_FAIL };
}
export function getRewardTypes() {
    return (dispatch) => {
        dispatch(getRewardTypesRequest());
        return communicate({
            url: 'v2/Bonus/Search',
            method: 'POST',
            data: {
                PageSize: -1,
                PageNumber: 0,
                OrderBy: 'Name',
                OrderDir: 'asc'
            }
        })
            .then((response) => {
            dispatch(getRewardTypesSuccess(response.data.Data));
        })
            .catch((error) => {
            dispatch(getRewardTypesFail());
            toastrError(error);
        });
    };
}
export function postRewardType(rewardType) {
    return (dispatch) => {
        dispatch(postRewardTypeRequest());
        return communicate({
            url: 'v2/Bonus/CreateUpdate',
            method: 'POST',
            data: rewardType
        })
            .then((response) => {
            toastrSuccess(response);
            dispatch(postRewardTypeSuccess(response.data.Data));
            return response.data.Data;
        })
            .catch((error) => {
            dispatch(postRewardTypeFail());
            toastrError(error);
        });
    };
}
export function deleteRewardType(rewardTypeId) {
    return (dispatch) => {
        dispatch(deleteRewardTypeRequest());
        return communicate({
            url: `v2/Bonus/Delete?Id=${rewardTypeId}`,
            method: 'DELETE'
        })
            .then((response) => {
            toastrSuccess(response);
            dispatch(deleteRewardTypeSuccess(rewardTypeId));
            return response.data.Data;
        })
            .catch((error) => {
            dispatch(deleteRewardTypeFail());
            toastrError(error);
            return Promise.reject(error);
        });
    };
}
export function getRewardRegistryRequestCall(data) {
    return communicate({ method: 'POST', url: 'v2/BonusEntry/Search', data });
}
export function getRewardRegistry(payload) {
    return (dispatch) => {
        dispatch(getRewardRegistryRequest());
        return getRewardRegistryRequestCall(payload)
            .then((response) => {
            dispatch(getRewardRegistrySuccess(response.data));
        })
            .catch((error) => {
            dispatch(getRewardRegistryFail());
            toastrError(error);
        });
    };
}
export function postRewardRegistryItemRequestCall(rewardRegistryItem) {
    return communicate({
        url: 'v2/BonusEntry/CreateUpdate',
        method: 'POST',
        data: rewardRegistryItem
    });
}
export function postRewardRegistryItemsListRequest(rewardRegistryItemsList) {
    return Promise.all(rewardRegistryItemsList.map(postRewardRegistryItemRequestCall))
        .then((responseArray) => {
        const responses = responseArray.filter((response) => response.data.Data);
        toastrSuccess(responseArray[0]);
        return responses;
    })
        .catch((error) => {
        toastrError(error);
        return Promise.reject(error);
    });
}
export function postRewardRegistryItem(rewardRegistryItem) {
    return (dispatch) => {
        return postRewardRegistryItemRequestCall(rewardRegistryItem)
            .then((response) => {
            toastrSuccess(response);
            dispatch(postRewardRegistryItemSuccess(response.data.Data));
            return response.data.Data;
        })
            .catch((error) => {
            toastrError(error);
            return Promise.reject(error);
        });
    };
}
export function deleteRewardRegistryItemRequestCall(rewardRegistryItemId) {
    return communicate({
        url: `v2/BonusEntry/Delete?Id=${rewardRegistryItemId}`,
        method: 'DELETE'
    });
}
export function deleteRewardRegistryItem(rewardRegistryItemId) {
    return (dispatch) => {
        return deleteRewardRegistryItemRequestCall(rewardRegistryItemId)
            .then((response) => {
            toastrSuccess(response);
            dispatch(deleteRewardRegistryItemSuccess(rewardRegistryItemId));
        })
            .catch((error) => {
            toastrError(error);
            return Promise.reject(error);
        });
    };
}
export function getRewardReport(payload) {
    return (dispatch) => {
        dispatch(getRewardReportRequest());
        return communicate({
            method: 'POST',
            url: 'v2/BonusEntry/Search',
            data: {
                ...payload,
                PageSize: -1
            }
        })
            .then((response) => {
            const data = response.data.Data;
            const { departments, totals } = new RewardReportParse(data);
            dispatch(getRewardReportSuccess({ departments, totals }));
        })
            .catch((error) => {
            dispatch(getRewardReportFail());
            toastrError(error);
        });
    };
}
export function getPersonRewards({ personIds } = {}) {
    return (dispatch) => {
        dispatch(getPersonRewardsRequest());
        return communicate({
            method: 'POST',
            url: 'v2/PersonBonus/Search',
            data: {
                PageSize: -1,
                ...(personIds && personIds.length > 0 && { PersonIds: personIds })
            }
        })
            .then((response) => {
            const data = response.data.Data;
            const personRewards = {};
            data.forEach((item) => {
                if (!personRewards[item.PersonId]) {
                    personRewards[item.PersonId] = [];
                }
                personRewards[item.PersonId].push(item);
            });
            dispatch(getPersonRewardsSuccess(personRewards));
        })
            .catch((error) => {
            dispatch(getPersonRewardsFail());
            toastrError(error);
        });
    };
}
export function postPersonReward(personReward) {
    return (dispatch) => {
        return communicate({
            url: 'v2/PersonBonus/CreateUpdate',
            method: 'POST',
            data: personReward
        })
            .then((response) => {
            toastrSuccess(response);
            const data = response.data.Data;
            if (personReward.Id) {
                dispatch(updatePersonRewardSuccess(data));
            }
            else {
                dispatch(postPersonRewardSuccess(data));
            }
            return response.data.Data;
        })
            .catch((error) => {
            toastrError(error);
            return Promise.reject(error);
        });
    };
}
export function deletePersonReward({ id, personId }) {
    return (dispatch) => {
        return communicate({
            url: `v2/PersonBonus/Delete?Id=${id}`,
            method: 'DELETE'
        })
            .then((response) => {
            toastrSuccess(response);
            dispatch(deletePersonRewardSuccess({ id, personId }));
        })
            .catch((error) => {
            toastrError(error);
            return Promise.reject(error);
        });
    };
}
export function getTimetableRewards({ userIds, period }) {
    return (dispatch) => {
        dispatch(getTimetableRewardsRequest());
        const [From, To] = period.split(',');
        const promises = [
            communicate({
                method: 'POST',
                url: 'v2/BonusEntry/Search',
                data: {
                    From,
                    To,
                    PersonIds: userIds,
                    PageSize: -1
                }
            }),
            communicate({
                method: 'POST',
                url: 'v2/Bonus/Search',
                data: {
                    PageSize: -1
                }
            })
        ];
        return Promise.all(promises)
            .then(([periodRewardsResponse, rewardTypesResponse]) => {
            const periodRewards = periodRewardsResponse.data.Data;
            const rewardTypes = rewardTypesResponse.data.Data;
            const { personsMap, columns } = new TimeTableRewardsParse(periodRewards, rewardTypes);
            dispatch(getTimetableRewardsSuccess({ personsMap, columns }));
        })
            .catch((error) => {
            dispatch(getTimetableRewardsFail());
            toastrError(error);
            return Promise.reject(error);
        });
    };
}
